export default __webpack_public_path__ + "static/media/video-game-svgrepo-com.9fee6c6a.svg";